"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PropTypes = require("prop-types");

var React = require("react"),
    css = require("classnames"),
    Utils = require("../../util/Utils");
/**
 * @class EllipsisLoader
 * @desc Loading indicator (animated ...) for fields which have server-side validation, etc.
 *
 * @param {string} [data-id="ellipsis-loader"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *          CSS class to set on the top HTML element (optional)
 * @param {boolean} loading
 *          While true, loading animation will be shown
 *
 * @example <EllipsisLoader id="my-loader" loading={this.state.isLoading} className="css-class" />
 */


var EllipsisLoader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EllipsisLoader, _React$Component);

  var _super = _createSuper(EllipsisLoader);

  function EllipsisLoader() {
    (0, _classCallCheck2.default)(this, EllipsisLoader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(EllipsisLoader, [{
    key: "render",
    value: function render() {
      if (this.props.loading) {
        var id = this.props.id || this.props["data-id"];
        var spanClass = css("icon-ellipsis", this.props.className, {
          ie9: Utils.isIE9()
        });
        return /*#__PURE__*/React.createElement("span", {
          className: spanClass,
          "data-id": id
        }, /*#__PURE__*/React.createElement("span", null));
      } else {
        return null;
      }
    }
  }]);
  return EllipsisLoader;
}(React.Component);

(0, _defineProperty2.default)(EllipsisLoader, "propTypes", {
  id: PropTypes.string,
  "data-id": PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool.isRequired
});
(0, _defineProperty2.default)(EllipsisLoader, "defaultProps", {
  "data-id": "ellipsis-loader"
});
module.exports = EllipsisLoader;